import { css, Interpolation, RuleSet } from 'styled-components';

// TODO v19.0.0 think about this types, it's too complicated and does not work as expected
type PlaceholderType = Interpolation<NoInfer<Record<string, unknown>>>[];
type LiteralsType = (literals: TemplateStringsArray, ...placeholders: PlaceholderType) => RuleSet<object>;

export type BreakPointsType = 'mobile' | 'tablet' | 'tabletOnly';
export type MediaStylesType = Record<BreakPointsType, LiteralsType>;

export const BREAKPOINTS = {
  xs: 375,
  sm: 640,
  md: 768,
  xl: 1400,
};

// Add all responsive mixins to single object
export const media = {} as MediaStylesType;

// <mobile> -> from 375px to 768px
media.mobile = (literals: TemplateStringsArray, ...placeholders: PlaceholderType) => {
  return css`
    @media screen and (max-width: ${BREAKPOINTS.md}px) {
      ${css(literals, ...placeholders)};
    }
  `;
};

// <tablet> -> from 769px to 1400px
media.tablet = (literals: TemplateStringsArray, ...placeholders: PlaceholderType) => {
  return css`
    @media screen and (max-width: ${BREAKPOINTS.xl}px) {
      ${css(literals, ...placeholders)};
    }
  `;
};

// <tablet only> -> between 769px and 1400px
media.tabletOnly = (literals: TemplateStringsArray, ...placeholders: PlaceholderType) => {
  return css`
    @media screen and (min-width: ${BREAKPOINTS.md}px) and (max-width: ${BREAKPOINTS.xl}px) {
      ${css(literals, ...placeholders)};
    }
  `;
};
